



























import { Vue, Component } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import SocialModule from '@/store/modules/Social';
import GeneralModule from '@/store/modules/General';

@Component({
  components: {
  },
})
export default class SeamlessKey extends Vue {
  SocialInstance = getModule(SocialModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  social = {}

  async created() {
    const resSocial = await this.SocialInstance.FetchSocial();
    this.social = resSocial.social;
  }

  async handleSocial() {
    this.GeneralInstance.toggleLoading(true);
    const res = await this.SocialInstance.EditSocial({ social: { ...this.social } });
    this.GeneralInstance.toggleLoading(false);
    this.GeneralInstance.ShowAlert({
      isAlert: true,
      alertMsg: res.message,
      alertColor: res.code === 0 ? 'success' : 'danger',
    });
  }
}
